import React from 'react';

import { IAttributionsAnswer } from '../../../../../api/types';
import { OpenAction } from '../../../../Chat/Actions/Open/OpenAction';

export const ChatPreviewFooter: React.FC<{ answer: IAttributionsAnswer }> = ({ answer }) => {
    return <OpenAction answer={answer} />;
};
